import { render, staticRenderFns } from "./Rate.vue?vue&type=template&id=5610f4b0&"
import script from "./Rate.vue?vue&type=script&lang=ts&"
export * from "./Rate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports